<script>
import apiUsers from '@/api/api-users.js'
import apiSettings from '@/api/api-settings.js'
import apiAnalyses from '@/api/api-analyses.js'
import apiSensors from '@/api/api-sensors.js'

import LoginComponent from './components/LoginComponent.vue'
import MenuComponent from './components/MenuComponent.vue'
import MainComponent from './components/main/MainComponent.vue'
import OrdersComponent from './components/orders/OrdersComponent.vue'
import SampleRegistrationComponent from './components/SampleRegistrationComponent.vue'
import PricelistComponent from './components/PricelistComponent.vue'
import FileImportComponent from './components/FileImportComponent.vue'
import TableForm from './components/common/TableForm.vue'
import QRCodesComponent from './components/QRCodesComponent.vue'
import UsersComponent from './components/UsersComponent.vue'
import SensorsAdminComponent from './components/SensorsAdminComponent.vue'
import SettingsImportComponent from './components/SettingsImportComponent.vue'

export default {
  name: 'App',

  components: {
    LoginComponent,
    MenuComponent,
    MainComponent,
    SampleRegistrationComponent,
    PricelistComponent,
    FileImportComponent,
    TableForm,
    QRCodesComponent,
    UsersComponent,
    OrdersComponent,
    SensorsAdminComponent,
    SettingsImportComponent
  },

  // Data
  data() {
    return {
      isDataLoad: false,

      isLogged: false,
      userId: -1,
      userLanguage: 'cz',
      userRole: 0,

      languageStrings: {},

      searchString: '',
      searchUIN: '',
      searchUID: '',
      resetLink: '',
      tabFromUrl: 0,

      showSampleRegistration: false,
      showPricelist: false,
      showFileImport: false,
      showTableForm: false,
      showQRCodes: false,
      showUsersForm: false,
      showOrders: false,
      showPlanner: false,
      showSensorsForm: false,
      showSettingsImport: false,

      tableFormTitle: '',
      tableFormHeaders: [],
      tableFormRows: []
    }
  },

  async created() {
    let verified = false

    if (localStorage.getItem('userId') != null) {
        let result = await apiUsers.getUser(localStorage.getItem('userId'))
        if (result.code === 0) {
          if (result.data.role != null) {
            this.userRole = result.data.role.id
          }

          if (result.data.language != null) {
            switch (result.data.language.id) {
              case 2:
                localStorage.setItem('language', 'en')
                break
              case 3:
                localStorage.setItem('language', 'pl')
                break
              default:
                localStorage.setItem('language', 'cs')
                break
            }
          }

          verified = true
        }
    }
    
    if (localStorage.getItem('language') != null) {
      this.setLanguage(localStorage.getItem('language'))
    }
    else {
      const language = (navigator.language || navigator.userLanguage).substr(0, 2)
      this.setLanguage(language)
    }

    // Check url params
    let urlParams = new URLSearchParams(window.location.search);
    const newParams = new URLSearchParams([...urlParams].map(([key, value]) => [key.toLowerCase(), value]));
    
    // UIN
    if (newParams.has('uin')) {
      this.searchUIN = newParams.get('uin')

      this.tabFromUrl = 0
      if (newParams.has('menu')) {
        switch (newParams.get('menu')) {
          case 'samples':
            this.tabFromUrl = 1
            break
          case 'analyses':
            this.tabFromUrl = 2
            break
          case 'sensors':
            this.tabFromUrl = 3
            break
          case 'events':
            this.tabFromUrl = 4
            break
          case 'details':
            this.tabFromUrl = 5
            break
        }
      }

      history.replaceState(null, null, window.location.origin + window.location.pathname)
    }
    
    // UID
    if (newParams.has('uid')) {
      this.searchUID = newParams.get('uid')

      this.tabFromUrl = 0
      if (newParams.has('menu')) {
        switch (newParams.get('menu')) {
          case 'samples':
            this.tabFromUrl = 1
            break
          case 'analyses':
            this.tabFromUrl = 2
            break
          case 'sensors':
            this.tabFromUrl = 3
            break
          case 'events':
            this.tabFromUrl = 4
            break
          case 'details':
            this.tabFromUrl = 5
            break
        }
      }

      history.replaceState(null, null, window.location.origin + window.location.pathname)
    }
    
    // Reset link
    if (newParams.has('reset')) {
      this.resetLink = newParams.get('reset')
      history.replaceState(null, null, window.location.origin + window.location.pathname)
    }

    // Sample registration
    if (newParams.has('sample')) {
      this.showSampleRegistration = true
    }

    if (verified) {
      this.userId = Number(localStorage.getItem('userId'))
      this.isLogged = true
    }
  },

  // Methods
  methods: {
    // Authorization
    async setAuthorizedUser(id) {
      this.userId = id

      let result = await apiUsers.getUser(this.userId)
      if (result.code === 0) {
        if (result.data.role != null) {
          this.userRole = result.data.role.id
        }

        if (result.data.language != null) {
          switch (result.data.language.id) {
            case 2:
              localStorage.setItem('language', 'en')
              break
            case 3:
              localStorage.setItem('language', 'pl')
              break
            default:
              localStorage.setItem('language', 'cs')
              break
          }
          this.setLanguage(localStorage.getItem('language'))
        }
      }

      this.isLogged = true
    },

    // Menu
    async selectedMenuItem(item) {
      let response = { code: 1, data: null }

      switch (item) {
        case 'logout':
          localStorage.removeItem('userId')
          localStorage.removeItem('token')
          localStorage.removeItem('refreshToken')

          location.reload()
          break
        
        case 'lang-en':
          if (this.userLanguage !== 'en') {
            let result = await apiUsers.getUser(localStorage.getItem('userId'))
            if (result.code === 0) {
              let user = result.data
              if (user.language != null) {
                user.language.id = 2
              }
              else {
                user.language = { "id": 2 }
              }
              await apiUsers.patchUser(user)
              localStorage.setItem('language', 'en')
            }

            this.setLanguage('en')
          }
          break

        case 'lang-cs':
          if (this.userLanguage !== 'cz') {
            let result = await apiUsers.getUser(localStorage.getItem('userId'))
            if (result.code === 0) {
              let user = result.data
              if (user.language != null) {
                user.language.id = 1
              }
              else {
                user.language = { "id": 1 }
              }
              await apiUsers.patchUser(user)
              localStorage.setItem('language', 'cs')
            }

            this.setLanguage('cs')
          }
          break

        case 'lang-pl':
          if (this.userLanguage !== 'pl') {
            let result = await apiUsers.getUser(localStorage.getItem('userId'))
            if (result.code === 0) {
              let user = result.data
              if (user.language != null) {
                user.language.id = 3
              }
              else {
                user.language = { "id": 3 }
              }
              await apiUsers.patchUser(user)
              localStorage.setItem('language', 'pl')
            }

            this.setLanguage('pl')
          }
          break

        case 'sample-registration':
          this.showSampleRegistration = true
          break

        case 'pricelist':
          this.showPricelist = true
          break

        case 'orders':
          this.showPlanner = false
          this.showOrders = !this.showOrders
          break

        case 'planner':
          this.showOrders = false
          this.showPlanner = !this.showPlanner
          break

        case 'file-import':
          this.showFileImport = true
          break

        case 'qr-codes':
          this.showQRCodes = true
          break

        case 'administration-analyses':
          this.tableFormTitle = this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.analysis001 != null ? this.languageStrings.ui.analysis001 : 'Analýzy'

          this.tableFormHeaders = [
              {
                  id: 'type',
                  name: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.analysis002 != null ? this.languageStrings.ui.analysis002 : 'Typ',
                  sort: true
              },
              {
                  id: 'pointer',
                  name: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.analysis003 != null ? this.languageStrings.ui.analysis003 : 'Ukazatel',
                  sort: true
              },
              {
                  id: 'unit',
                  name: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.analysis004 != null ? this.languageStrings.ui.analysis004 : 'Jednotka',
                  sort: true
              },
              {
                  id: 'norm',
                  name: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.analysis005 != null ? this.languageStrings.ui.analysis005 : 'Norma',
                  sort: true
              },
              {
                  id: 'accreditation',
                  name: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.analysis006 != null ? this.languageStrings.ui.analysis006 : 'Akreditace',
                  sort: true
              },
              {
                  id: 'id-als',
                  name: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.analysis007 != null ? this.languageStrings.ui.analysis007 : 'ID ALS',
                  sort: true
              },
              {
                  id: 'id-linde',
                  name: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.analysis008 != null ? this.languageStrings.ui.analysis008 : 'ID LINDE',
                  sort: true
              },
              {
                  id: 'volume',
                  name: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.analysis009 != null ? this.languageStrings.ui.analysis009 : 'Objem vzorku [ml]',
                  sort: true
              },
              {
                  id: 'group',
                  name: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.analysis010 != null ? this.languageStrings.ui.analysis010 : 'ID skupiny',
                  sort: true
              },
              {
                  id: 'graph',
                  name: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.analysis011 != null ? this.languageStrings.ui.analysis011 : 'Pořadí grafů',
                  sort: true
              }
          ]

          this.tableFormRows = []
          response = await apiAnalyses.getAnalyzes()
          if (response.code === 0) {
            for (let i = 0; i < response.data.length; i++) {
              this.tableFormRows.push({
                id: response.data[i].id,
                selected: false,
                cells: [
                  {
                    id: 'type',
                    contenttype: 'text',
                    content: response.data[i].analasisType != null && response.data[i].analasisType.name != null ? this.languageStrings != null && this.languageStrings.ui != null ? this.languageStrings.ui[response.data[i].analasisType.name] : response.data[i].analasisType.name : ''
                  },
                  {
                    id: 'pointer',
                    contenttype: 'text',
                    content: response.data[i].pointer != null ? response.data[i].pointer : ''
                  },
                  {
                    id: 'unit',
                    contenttype: 'text',
                    content: response.data[i].unit != null ? response.data[i].unit : ''
                  },
                  {
                    id: 'norm',
                    contenttype: 'text',
                    content: response.data[i].norm != null ? response.data[i].norm : ''
                  },
                  {
                    id: 'accreditation',
                    contenttype: 'text',
                    content: response.data[i].accreditation != null && response.data[i].accreditation ? (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.form003 != null ? this.languageStrings.ui.form003 : 'Ano') : (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.form004 != null ? this.languageStrings.ui.form004 : 'ne')
                  },
                  {
                    id: 'id-als',
                    contenttype: 'text',
                    content: response.data[i].idAls != null ? response.data[i].idAls : ''
                  },
                  {
                    id: 'id-linde',
                    contenttype: 'text',
                    content: response.data[i].idLinde != null ? response.data[i].idLinde : ''
                  },
                  {
                    id: 'volume',
                    contenttype: 'text',
                    content: response.data[i].volume != null ? response.data[i].volume.toString() : ''
                  },
                  {
                    id: 'group',
                    contenttype: 'text',
                    content: response.data[i].group != null ? response.data[i].group.toString() : ''
                  },
                  {
                    id: 'graph',
                    contenttype: 'text',
                    content: response.data[i].graph != null ? response.data[i].graph.toString() : ''
                  }
                ]
              })
            }
          }

          this.showTableForm = true
          break

        case 'administration-regions':
          this.tableFormTitle = this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.region001 != null ? this.languageStrings.ui.region001 : 'Regiony'

          this.tableFormHeaders = [
              {
                  id: 'name',
                  name: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.region002 != null ? this.languageStrings.ui.region002 : 'Název',
                  sort: true
              }
          ]

          this.tableFormRows = []
          response = await apiSettings.getRegions()
          if (response.code === 0) {
            for (let i = 0; i < response.data.length; i++) {
              this.tableFormRows.push({
                id: response.data[i].id,
                selected: false,
                cells: [
                  {
                    id: 'name',
                    contenttype: 'text',
                    content: response.data[i].name
                  }
                ]
              })
            }
          }

          this.showTableForm = true
          break

        case 'administration-sensors-parameters':
          this.tableFormTitle = this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.sensor001 != null ? this.languageStrings.ui.sensor001 : 'Parametry senzorů'

          this.tableFormHeaders = [
              {
                  id: 'name',
                  name: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.sensor002 != null ? this.languageStrings.ui.sensor002 : 'Id',
                  sort: true
              },
              {
                  id: 'grafana-url',
                  name: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.sensor003 != null ? this.languageStrings.ui.sensor003 : 'Grafana URL',
                  sort: false
              },
              {
                  id: 'parameters',
                  name: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.sensor004 != null ? this.languageStrings.ui.sensor004 : 'Parametry',
                  sort: false
              }
          ]

          this.tableFormRows = []
          response = await apiSensors.getParameterSets()
          if (response.code === 0) {
            for (let i = 0; i < response.data.length; i++) {
              this.tableFormRows.push({
                id: response.data[i].id,
                selected: false,
                cells: [
                  {
                    id: 'name',
                    contenttype: 'text',
                    content: response.data[i].id
                  },
                  {
                    id: 'grafana-url',
                    contenttype: 'text',
                    content: response.data[i].grafanaUrl != null ? response.data[i].grafanaUrl : ''
                  },
                  {
                    id: 'parameters',
                    contenttype: 'text',
                    content: response.data[i].parameters.map(p => p.register + ' : ' + p.idAls).join(' , ')
                  }
                ]
              })
            }
          }

          this.showTableForm = true
          break

        case 'administration-sensors-sensors':
          this.showSensorsForm = true
          break

        case 'administration-users':
          this.showUsersForm = true
          break

        case 'administration-oil-types':
          this.tableFormTitle = this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.menu025 != null ? this.languageStrings.ui.menu025 : 'Typy olejů'

          this.tableFormHeaders = [
              {
                  id: 'class',
                  name: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.oilType001 != null ? this.languageStrings.ui.oilType001 : 'Třída',
                  sort: true
              },
              {
                  id: 'iso',
                  name: 'ISO 6743',
                  sort: true
              },
              {
                  id: 'din',
                  name: 'DIN 51502',
                  sort: true
              }
          ]

          this.tableFormRows = []
          response = await apiSettings.getOilTypes(this.userLanguage)
          if (response.code === 0) {
            for (let i = 0; i < response.data.length; i++) {
              this.tableFormRows.push({
                id: response.data[i].id,
                selected: false,
                cells: [
                  {
                    id: 'class',
                    contenttype: 'text',
                    content: response.data[i].class
                  },
                  {
                    id: 'iso',
                    contenttype: 'text',
                    content: response.data[i].isO6743 != null ? response.data[i].isO6743 : ''
                  },
                  {
                    id: 'din',
                    contenttype: 'text',
                    content: response.data[i].diN51502 != null ? response.data[i].diN51502 : ''
                  }
                ]
              })
            }
          }

          this.showTableForm = true
          break

        case 'administration-viscosity-classes':
          this.tableFormTitle = this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.menu026 != null ? this.languageStrings.ui.menu026 : 'Viskozitní třídy'

          this.tableFormHeaders = [
              {
                  id: 'name',
                  name: this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.viscosityClassType001 != null ? this.languageStrings.ui.viscosityClassType001 : 'Název',
                  sort: true
              }
          ]

          this.tableFormRows = []
          response = await apiSettings.getViscosityClasses()
          if (response.code === 0) {
            for (let i = 0; i < response.data.length; i++) {
              this.tableFormRows.push({
                id: response.data[i].id,
                selected: false,
                cells: [
                  {
                    id: 'name',
                    contenttype: 'text',
                    content: response.data[i].name
                  }
                ]
              })
            }
          }

          this.showTableForm = true
          break

        case 'administration-import-configuration':
          this.showSettingsImport = true
          break
      }
    },

    // Language
    async setLanguage(language) {
      switch (language) {
        case 'cs':
        case 'sk':
          this.userLanguage = 'cz'
          break

        case 'pl':
          this.userLanguage = 'pl'
          break
        
        default:
          this.userLanguage = 'en'
          break
      }

      let response = await apiSettings.getLanguages(this.userLanguage)
      if (response.code === 0) {
        this.languageStrings = response.data
      }
    },

    // Search
    async search(value) {
      this.searchString = value
    },

    // Sample registration
    sampleRegistrationClosed() {
      this.showSampleRegistration = false
    },

    // Pricelist
    pricelistClosed() {
      this.showPricelist = false
    },

    // File import
    fileImportClosed() {
      this.showFileImport = false
    },

    // Table form
    tableFormClosed() {
      this.showTableForm = false
    },

    // Sensors form
    sensorsFormClosed() {
      this.showSensorsForm = false
    },

    // Users form
    usersFormClosed() {
      this.showUsersForm = false
    },

    // QR codes
    QRCodesClosed() {
      this.showQRCodes = false
    },

    // Settings import
    settingsImportClosed() {
      this.showSettingsImport = false
    }
  }
}
</script>


<template>
  <LoginComponent v-if="!isLogged" @set-authorized-user="setAuthorizedUser" :language-strings="languageStrings" :user-language="userLanguage" :reset-link="resetLink" />

  <div v-if="isDataLoad" class="data-load">
    <div class="cols justify-center align-center fullsize">
      <div class="rows gap-10 message-box-load">
        <h3>{{ userLanguage === 'cz' ? 'Načítám data...' : 'Loading data...' }}</h3>
      </div>
    </div>
  </div>

  <div v-if="isLogged" class="app-main">
    <MenuComponent @selected-menu-item="selectedMenuItem" @search="search" :user-language="userLanguage" :language-strings="languageStrings" :role="userRole" />

    <MainComponent v-if="userRole >= 1 && userRole <= 4 && !showOrders && !showPlanner" :user-language="userLanguage" :language-strings="languageStrings" :user-id="userId" :role="userRole" :search-string="searchString" :searchUIN="searchUIN" :searchUID="searchUID" :tab-from-url="tabFromUrl"></MainComponent>
    
    <OrdersComponent v-if="userRole >= 1 && userRole <= 4 && showOrders && !showPlanner" :user-language="userLanguage" :language-strings="languageStrings" :user-id="userId" :role="userRole" :search-string="searchString"></OrdersComponent>

    <SampleRegistrationComponent v-if="isLogged && showSampleRegistration" @form-closed="sampleRegistrationClosed" :user-language="userLanguage" :language-strings="languageStrings" :user-id="userId" :role="userRole"></SampleRegistrationComponent>

    <PricelistComponent v-if="showPricelist" @form-closed="pricelistClosed" :language-strings="languageStrings"></PricelistComponent>
    
    <FileImportComponent v-if="showFileImport" @form-closed="fileImportClosed" :language-strings="languageStrings"></FileImportComponent>
    
    <SettingsImportComponent v-if="showSettingsImport" @form-closed="settingsImportClosed" :language-strings="languageStrings"></SettingsImportComponent>

    <TableForm v-if="showTableForm" @form-closed="tableFormClosed" :title="tableFormTitle" :headers="tableFormHeaders" :rows="tableFormRows"></TableForm>
    
    <QRCodesComponent v-if="showQRCodes" @form-closed="QRCodesClosed" :language-strings="languageStrings"></QRCodesComponent>

    <UsersComponent v-if="showUsersForm" @form-closed="usersFormClosed" :userLanguage="userLanguage" :language-strings="languageStrings"></UsersComponent>

    <SensorsAdminComponent v-if="showSensorsForm" @form-closed="sensorsFormClosed" :userLanguage="userLanguage" :language-strings="languageStrings" :user-id="userId"></SensorsAdminComponent>
  </div>
</template>